import { Navigate, useSearchParams } from 'react-router-dom';
import { useToken } from '../../lib/session';
import { LoginAuthPanel } from './LoginAuthPanel';
import { LoginBrandPanel } from './LoginBrandPanel';

function safeNextPath(raw: string | null): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return '/';
  return raw;
}

export function LoginPage() {
  const token = useToken();
  const [params] = useSearchParams();
  if (token) return <Navigate to={safeNextPath(params.get('next'))} replace />;

  return (
    <div
      className="login-surface min-h-screen"
      style={{ backgroundColor: '#11110F', ['--gs-ink' as string]: '#12141a' }}
    >
      <div className="grid min-h-screen lg:grid-cols-[minmax(0,55fr)_minmax(0,45fr)]">
        <div className="order-2 min-h-screen lg:order-1 lg:min-h-full">
          <LoginBrandPanel />
        </div>
        <div className="order-1 min-h-screen lg:order-2 lg:min-h-full">
          <LoginAuthPanel />
        </div>
      </div>
    </div>
  );
}
